module.exports = __webpack_public_path__ + "static/AmericanTraditional-7680e8e72c2f2897223bf40f4531fe56.jpg";